import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonServices } from 'src/app/Common/CommonServices';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { WebinarRoomOwnerDTO } from 'src/app/Services/WOWApi.Service';

@Component({
    selector: 'app-update-image',
    templateUrl: './update-image.component.html',
    styleUrls: ['./update-image.component.css'],
    standalone: false
})
export class UpdateImageComponent implements OnInit {
  isRoomImageUpdate = false;
  label = '';
  fileToUpload: any;
  roomId: number;
  existingRoomImage: string | null = null;
  roomDTO: WebinarRoomOwnerDTO = {} as WebinarRoomOwnerDTO;
  imageSrcPreview: string | ArrayBuffer | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private commonServices: CommonServices,
    private customService: CustomServiceService,
    private dialogRef: MatDialogRef<UpdateImageComponent>
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    if (this.data !== undefined && this.data !== null) {
      this.isRoomImageUpdate = this.data.isRoomImageUpdate;
      this.roomId = this.data.roomId;
      this.label = 'Update Room Image';
      this.existingRoomImage = this.data.roomImage
        ? 'data:image/png;base64,' + this.data.roomImage
        : null;
      this.roomDTO = JSON.parse(JSON.stringify(this.data.room));
    }
  }

  onRoomImageFileChange(event) {
    if (!event.target.files)
      return;

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.commonServices.showMessage("Error", "Only images are supported.");
      return;
    }
    this.fileToUpload = event.target.files[0];

    const reader = new FileReader();

    reader.onload = (e) => {
      this.imageSrcPreview = reader.result;
    };

    reader.readAsDataURL(this.fileToUpload);
  }

  onUpdate() {
    this.customService.UpdateBusinessImageForRoom(this.fileToUpload, this.roomId, this.roomDTO.roomDescription).subscribe(res => {
      console.log(res);
      if (res === true) {
        this.commonServices.showMessage('success', 'Room details updated succesfully.', 4);
        this.dialogRef.close({action: 'success', description: this.roomDTO.roomDescription});
      } else {
        this.commonServices.showMessage('error', 'Could not update room details', 4);
      }
    }, error => {
      this.commonServices.showMessage('error', error, 5);
    });
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}


